export default [
//   用于咪咕俱乐部小程序投放页面
// // 月月领 - 兔年惠享包
//     {
//         path: '/MonthlyCollar',
//         name: 'MonthlyCollar',
//         meta: {
//             title: '兔年惠享包',
//         },
//         component: () => import('@/view/otherPage/OtherExclusive19.99')
//     },
//     {
//         path: '/MonthlyCollar-h',
//         name: 'MonthlyCollar',
//         meta: {
//             title: '兔年惠享包',
//         },
//         component: () => import('@/view/otherPage/OtherExclusive19.99')
//     },
//     {
//         path: '/MonthlyCollar-o',
//         name: 'MonthlyCollar-o',
//         meta: {
//             title: '兔年惠享包',
//         },
//         component: () => import('@/view/otherPage/OtherExclusive19.99')
//     },
//     {
//         path: '/MonthlyCollar-v',
//         name: 'MonthlyCollar-v',
//         meta: {
//             title: '兔年惠享包',
//         },
//         component: () => import('@/view/otherPage/OtherExclusive19.99')
//     },
//     {
//         path: '/MonthlyCollar-m',
//         name: 'MonthlyCollar-m',
//         meta: {
//             title: '兔年惠享包',
//         },
//         component: () => import('@/view/otherPage/OtherExclusive19.99')
//     },
//     //  生活缴费月月领
//     {
//         path: '/MonthlyCollarLife',
//         name: 'MonthlyCollarLife',
//         meta: {
//             title: '生活缴费月月领',
//         },
//         component: () => import('@/view/otherPage/OtherLifePage')
//     },
//     //  出行生活天天享
//     {
//         path: '/MonthlyCollarTravel',
//         name: 'MonthlyCollarTravel',
//         meta: {
//             title: '出行生活天天享',
//         },
//         component: () => import('@/view/otherPage/OtherTravelPage')
//     },
]
